import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { BaseSyntheticEvent, useState } from 'react'

import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ButtonCellProps = {
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>
  disabled: boolean
  isSubmitting: boolean
}
export const ButtonCell: Cell<ButtonCellProps> = ({
  onSubmit,
  disabled,
  isSubmitting,
}) => {
  const { t } = useTranslation('firstComeFirstServedDetail')
  const [checked, setChecked] = useState<boolean>(false)
  const { router } = useRouter()

  return (
    <CellFrame sx={{ py: 4 }}>
      <Stack spacing={4} alignItems="center">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onClick={() => setChecked(prevState => !prevState)}
            />
          }
          label={
            <Typography variant="caption" color="text.secondary">
              {t('checkBoxLabel')}
            </Typography>
          }
        />
        <Button
          size="large"
          disabled={!checked || disabled}
          loading={isSubmitting}
          sx={{ width: 212 }}
          onClick={onSubmit}
        >
          {t('submit')}
        </Button>
        <Button
          variant="text"
          size="small"
          sx={{ width: 212 }}
          onClick={() => router.goBack()}
        >
          {t('back')}
        </Button>
      </Stack>
    </CellFrame>
  )
}
